import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from '../../../material.module';
import { MenuItem } from '@lib/interfaces/menu-items.interface';
import { SettingsService } from '@lib/services/settings/settings.service';
import { environment } from '@env/environment';
import { lowerMenuItems, getMenuItems } from '@lib/constants/sidemenu.constants';
import { TenantConfigurationService } from '@lib/services';
import { Store } from '@ngrx/store';
import { selectEncryptedTenantKey } from '@store/selectors/tenant.selectors';
import { AppState } from '@store/app.state';
import { Subject, takeUntil } from 'rxjs';
import * as CryptoJS from 'crypto-js';

@Component({
    standalone: true,
    imports: [CommonModule, RouterModule, AngularMaterialModule],
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent implements OnDestroy {
    @Output() collapseStatusChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    isCollapseNav = false;
    isTenantDropdownOpen = true; 
    tenantsList=[{tenant:'NymCard', selected:true},
        {tenant:'Tenant 1', selected:false},
        {tenant:'Tenant 2', selected:false},
        {tenant:'Tenant 3', selected:false},
        {tenant:'Tenant 4', selected:false},
        {tenant:'Tenant 5', selected:false}];

    tenantKey = '';
    imgUrl = '';
    activeTabForTenant0 = ['Call Center', 'Customers', 'Cards', 'Access Management'];
    version = environment.version;
    menuItems: MenuItem[];
    lowerMenuItems: MenuItem[];
        private destroy$ = new Subject<void>(); // Add destroy$ for cleanup
    constructor(private router: Router, public settingService: SettingsService, public tenantConfigurationService: TenantConfigurationService, private store: Store<AppState>) {
        this.store
                    .select(selectEncryptedTenantKey)
                    .pipe(takeUntil(this.destroy$))
                    .subscribe((key: string | null) => {
                        if (key) {
                            this.tenantKey = CryptoJS.AES.decrypt(key, environment.tenantKeyPassphrase).toString(CryptoJS.enc.Utf8);
                            this.activeTabForTenant0 = localStorage.getItem('id') == 'administrator' ? ['Call Center', 'Customers', 'Cards', 'Access Management'] : ['Call Center', 'Customers', 'Cards'];
                            this.imgUrl = tenantConfigurationService.getImageSpecificToTenant(this.tenantKey, 'sidenav_logo');
                            this.menuItems = getMenuItems();
                            this.lowerMenuItems = lowerMenuItems;
                        }
                    });

    }
    panelOpenState = false;

    ngOnDestroy(): void {
        this.destroy$.next(); // Emit to complete the observable
        this.destroy$.complete(); // Complete the subject
    }

    checkExpandedItem(item: string): boolean {
        return this.router.url.includes(item);
    }

    collapseNav() {
        this.isCollapseNav = true;
        this.collapseStatusChange.emit(this.isCollapseNav);
    }

    unCollapseNav() {
        this.isCollapseNav = false;
        this.collapseStatusChange.emit(this.isCollapseNav);
    }

    toggleCollapseNav() {
        this.isCollapseNav = !this.isCollapseNav;
        this.collapseStatusChange.emit(this.isCollapseNav);
    }

    handleMenuClick(item: MenuItem) {
        if (this.isCollapseNav && item.title === 'Settings') {
            this.router.navigate(['/control-center/settings']);
        }
    }

    handleExpandClick(item: MenuItem, event: MouseEvent) {
        if (this.isCollapseNav && item.title === 'Settings') {
            event.stopPropagation();
            this.router.navigate(['/control-center/settings']);
        }
    }
    toggleTenantDropdown() {
        this.isTenantDropdownOpen = !this.isTenantDropdownOpen;
    }
    selectTenant(selectedTenant: any): void {
        this.tenantsList.forEach(tenant => {
            tenant.selected = tenant === selectedTenant;
        });
    }
}
